import { render, staticRenderFns } from "./shopify_location_modal.vue?vue&type=template&id=320f0a0a&scoped=true&"
import script from "./shopify_location_modal.vue?vue&type=script&lang=js&"
export * from "./shopify_location_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320f0a0a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('320f0a0a')) {
      api.createRecord('320f0a0a', component.options)
    } else {
      api.reload('320f0a0a', component.options)
    }
    module.hot.accept("./shopify_location_modal.vue?vue&type=template&id=320f0a0a&scoped=true&", function () {
      api.rerender('320f0a0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/shopify/location/shopify_location_modal.vue"
export default component.exports